import { FormControl } from '@mui/material';
import DateRangeBaseField, {
  DateRangeBaseFieldProps,
} from './date-range-base-field/date-range-base-field.component';
import { useController } from 'react-hook-form';
import { DateTime } from 'luxon';

type DateRange = [DateTime, DateTime]; // Define the type for the date range

type DateRangeFieldProps = {
  name: string;
} & Omit<DateRangeBaseFieldProps, 'value'>;

const DateRangeField = ({ name, ...rest }: DateRangeFieldProps) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name });

  const handleDateRangeChange = (value: DateRange) => {
    onChange([value[0].toISO(), value[1]?.endOf('day').toISO()]);
  };

  return (
    <FormControl data-testid="DateRangeField" error={!!error}>
      <DateRangeBaseField
        value={[
          value?.[0] ? DateTime.fromISO(String(value[0])) : null,
          value?.[1] ? DateTime.fromISO(String(value[1])) : null,
        ]}
        onChange={value => handleDateRangeChange(value)}
        error={error}
        {...rest}
      />
    </FormControl>
  );
};

export default DateRangeField;
